<template>
  <div id="login" class="login">
    <div class="wrapper">
      <div class="logo"></div>
      <div class="content">
        <div class="input-box">
          <span>手机号</span>
          <input class="phone" placeholder="请输入手机号" v-model="phone" maxlength="11"
            oninput="value=value.replace(/[^\d]/g,'')" />
        </div>
        <div class="input-box">
          <span>密码</span>
          <input class="password" placeholder="请输入密码" v-model="password" type="password" maxlength="16" />
        </div>
        <button id="loginbtn" class="loginbtn" :style="{backgroundColor:activeColor}" @click="loginClick">登录</button>
        <div class="register">
          <div class="image"></div>
          <div class="left" @click="registerClick">立即注册</div>
          <div class="right" @click="retrieveClick">忘记密码？</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      phone: '',
      password: '',
      code: '',
      activeColor: '#fecdcd'
    }
  },
  methods: {
    registerClick: function () {
      this.$router.push({ path: '/register' })
    },
    retrieveClick: function () {
      this.$router.push({ path: '/retrieve' })
    },
    checkParam: function () {
      if (this.utils.isNull(this.phone)) {
        Toast('请输入手机号！')
        return false
      }
      if (!this.utils.isPhone(this.phone)) {
        Toast('请正确输入手机号！')
        return false
      }
      if (this.utils.isNull(this.password)) {
        Toast('请输入密码！')
        return false
      }
      return true
    },
    loginClick: function () {
      if (this.checkParam() === false) {
        return
      }
      let param = {
        'account': this.phone,
        'password': this.password
      }
      var _this = this

      this.utils.POST(this.accountUrl + '/account/login', param, function (data) {
        _this.getInfo()
        localStorage.removeItem('openId')
        // _this.$router.push('/')
      })
    },
    getInfo: function () {
      localStorage.setItem('isLogin', 1)
      var _this = this
      this.utils.GET(this.companyUrl + '/ent/json',
        function (data) {
          localStorage.setItem('userinfo', JSON.stringify(data.data))
          // 返回 上一页
          // console.log(_this)
          // console.log(_this.$router.from)
          if (parseInt(_this.$route.query.back) === 1) {
            _this.$router.go(-1)
          } else {
            _this.$router.push({ path: 'home' })
          }
        })
    }
  },
  watch: {
    phone: function (val) {
      if (val > 11) {
        this.phone = val.slice(0, 11)
      }
      this.activeColor = '#fecdcd'
      if (this.phone.length > 0 && this.password.length > 0) {
        this.activeColor = '#c41335'
      }
    },
    password: function (val) {
      this.activeColor = '#fecdcd'
      if (this.phone.length > 0 && this.password.length > 0) {
        this.activeColor = '#c41335'
      }
    }
  },
  mounted () {
    // console.log(this)
    // console.log(this.$router.history)
    // console.log(window.history.length)
  }
}
</script>

<style scoped>
.wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
}
.wrapper .logo {
  position: absolute;
  top: 60px;
  left: calc(50% - 55px);
  width: 110px;
  height: 94px;
  background-image: url("../../assets/icon-logo.png");
  background-size: cover;
  background-position: center center;
  z-index: 100;
}
.wrapper .content {
  position: absolute;
  top: 100px;
  left: 15px;
  right: 15px;
  width: calc(100% - 30px);
  height: 300px;
  background-color: #ffffff;
  /*background-color: yellow;*/
}
.content .input-box {
  position: relative;
  top: 80px;
  left: 20px;
  width: calc(100% - 40px);
  height: 54px;
  line-height: 54px;
  border-bottom: solid #eeeeee 1px;
  box-sizing: border-box;
  /*background-color: yellow;*/
}
.content .input-box span {
  position: absolute;
  font-size: 15px;
  color: #000000;
  top: 20px;
  height: 15px;
  line-height: 15px;
}
.content .input-box input {
  position: absolute;
  left: 70px;
  height: 53px;
  width: calc(100% - 70px);
  line-height: 53px;
  font-size: 15px;
  color: #000000;
  border: none;
  padding: 15px 0;
  line-height: 24px;
  /*background-color: pink;*/
}
.content .loginbtn {
  position: relative;
  top: 100px;
  left: 20px;
  width: calc(100% - 40px);
  height: 40px;
  line-height: 40px;
  background-color: #fecdcd;
  text-align: center;
  color: #ffffff;
  font-size: 15px;
  border-radius: 20px;
}
.content .register {
  position: relative;
  top: 115px;
  left: 20px;
  width: calc(100% - 40px);
  height: 15px;
  /*background-color: yellow;*/
}
.content .register .image {
  position: absolute;
  top: 3px;
  left: 1px;
  width: 9px;
  height: 8px;
  background-image: url("../../assets/icon-arrow-red.png");
  background-size: cover;
  background-position: center;
}
.content .register .left {
  display: inline-block;
  position: absolute;
  top: 0px;
  left: 15px;
  height: 15px;
  font-size: 12px;
  color: #c41335;
  line-height: 15px;
}
.content .register .right {
  display: inline-block;
  position: absolute;
  top: 0px;
  right: 0px;
  height: 15px;
  font-size: 12px;
  color: #999999;
  line-height: 15px;
}

.login .footer {
  z-index: 1000;
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 110px;
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/login.vue